export * from 'prosemirror-model';
